import ACTION_TYPE from '../../store/ACTION_TYPE';
import createReducerFunction from '../../store/reducerCreator';

interface State {}

const initialState = {
    appDefinitionFile: null,
    appId: '',
    isAppDefinitionLoaded: false,
    isAppDefinitionValid: true,
    isVisible: false,
    name: '',
    isConfigurationVisible: false,
    showConfirmation: false,
    validationErrorDownload: false,
    validationErrorMessage: '',
    validationErrorDetails: '', // null?
};

interface AppDefinitionFile {
    name: string;
}

interface Action {
    type:
        | ACTION_TYPE.CLOSE_SIDELOADED_APP_MODAL
        | ACTION_TYPE.OPEN_SIDELOADED_APP_MODAL
        | ACTION_TYPE.CLOSE_SIDELOADED_APP_CONFIGURATION_MODAL
        | ACTION_TYPE.OPEN_SIDELOADED_APP_CONFIGURATION_MODAL
        | ACTION_TYPE.LOAD_APP_DEFINITION
        | ACTION_TYPE.ADD_SIDELOADED_APP_REJECTED
        | ACTION_TYPE.ADD_SIDELOADED_APP_FULFILLED
        | ACTION_TYPE.RELOAD_APP_DEFINITION
        | ACTION_TYPE.REUPLOAD_SIDELOADED_APP_REJECTED
        | ACTION_TYPE.REUPLOAD_SIDELOADED_APP_FULFILLED
        | ACTION_TYPE.REMOVE_SIDELOADED_APP_FULFILLED
        | ACTION_TYPE.REMOVE_SIDELOADED_APP_REJECTED
        | ACTION_TYPE.SHOW_REMOVE_SIDELOADED_APP_CONFIRMATION_MODAL;
    error: boolean;
    appId?: string;
    name?: string;
    appDefinitionFile?: AppDefinitionFile;
    payload?: {
        details: string;
        message: string;
        statusCode?: number;
    };
}

export default createReducerFunction<State, Action>({
    initialState,
    reducers: {
        // add
        [ACTION_TYPE.CLOSE_SIDELOADED_APP_MODAL]: () => initialState,
        [ACTION_TYPE.OPEN_SIDELOADED_APP_MODAL]: (state) => ({ ...state, isVisible: true }),

        // configuration
        [ACTION_TYPE.CLOSE_SIDELOADED_APP_CONFIGURATION_MODAL]: () => initialState,
        [ACTION_TYPE.OPEN_SIDELOADED_APP_CONFIGURATION_MODAL]: (state, { appId, name }) => ({
            ...initialState,
            appId,
            name,
            isConfigurationVisible: true,
        }),

        // logic
        [ACTION_TYPE.LOAD_APP_DEFINITION]: (state, { appDefinitionFile }) => ({
            ...state,
            appDefinitionFile,
            isAppDefinitionLoaded: true,
            isAppDefinitionValid: true,
            validationErrorDownload: false,
            validationErrorDetails: '',
            validationErrorMessage: '',
        }),
        [ACTION_TYPE.ADD_SIDELOADED_APP_REJECTED]: (state, { payload }) => ({
            ...state,
            isAppDefinitionValid: false,
            validationErrorDownload: !!payload?.details,
            validationErrorMessage: payload?.message,
            validationErrorDetails: payload?.details || '',
        }),
        [ACTION_TYPE.ADD_SIDELOADED_APP_FULFILLED]: () => initialState,
        [ACTION_TYPE.RELOAD_APP_DEFINITION]: (state, { appDefinitionFile }) => ({
            ...state,
            appDefinitionFile,
            isAppDefinitionLoaded: true,
            isAppDefinitionValid: true,
            validationErrorDownload: false,
            validationErrorDetails: '',
            validationErrorMessage: '',
        }),
        [ACTION_TYPE.REUPLOAD_SIDELOADED_APP_REJECTED]: (state, { payload }) => ({
            ...state,
            isAppDefinitionValid: false,
            validationErrorDownload: !!payload?.details,
            validationErrorMessage: payload?.message,
            validationErrorDetails: payload?.details || '',
        }),
        [ACTION_TYPE.REUPLOAD_SIDELOADED_APP_FULFILLED]: () => initialState,
        [ACTION_TYPE.REMOVE_SIDELOADED_APP_FULFILLED]: () => initialState,
        [ACTION_TYPE.REMOVE_SIDELOADED_APP_REJECTED]: (state, { error, payload }) => {
            if (error && payload?.statusCode === 404) {
                return initialState;
            }

            return state;
        },
        [ACTION_TYPE.SHOW_REMOVE_SIDELOADED_APP_CONFIRMATION_MODAL]: (state) => ({ ...state, showConfirmation: true }),
    },
});
